<template>
    <div v-if="game" style="background-color: pink;">
        <h3>Підтвердження гри</h3>

        <div
            v-for="player in game.players"
            :key="player.id"
            :style="{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                margin: '8px 0',
                border: `2px solid ${player.status === 0 ? 'black' : (player.status === 1 ? 'green' : 'red')}`,
                borderRadius: '8px',
                padding: '8px'
            }" >
            <img
                :src="player.photo"
                :alt="player.name"
                style="width: 48px; height: 48px; border-radius: 50%; object-fit: cover;"
            />
            <div>
                <div>{{ player.name }}</div>
                <div style="font-size: 12px; color: gray;">{{ player.Rate }} рейтинг</div>
            </div>
        </div>
        <div v-if="!IsAnswerReady">
            <button @click="approve">Підтвердити</button>
            <button @click="decline">Відхилити</button>
        </div>
    </div>
</template>
<script setup>
import { ref } from 'vue'
import axios from 'axios';
import { geks } from '../composables/geks'
const { game, connection } = geks()
const IsAnswerReady = ref(false)

connection.on("ApprovedGame", (playerId) => {
    if (!game.value) return
    const player = game.value.players.find(p => p.id === playerId)
    if (player) player.status = 1
})

connection.on("DeclinedGame", (playerId) => {
    //if (!game.value) return
    //const player = game.value.players.find(p => p.id === playerId)
    //if (player) player.status = 2
    //game.value = {}
    //IsAnswerReady.value = false
})

async function approve() {
    await axios.get(process.env.VUE_APP_SERVER_GEKS + "/ApproveGame/" + game.value.id);
    IsAnswerReady.value = true
}

async function decline() {
    //await connection.invoke("DeclineGame", game.value.id)
    //IsAnswerReady.value = true
    //game.value = {}
}
</script>